import React, { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { withRouter } from "react-router-dom";
import { refreshDatabase } from "../../shared/store/actions/database";
import { resetStore } from "../../shared/store/actions/store";
import SettingsWebUI from "../../components/Advisor/Settings";

class Settings extends Component {
  render() {
    return (
      <SettingsWebUI
        database={this.props.database}
        onRefreshDatabase={this.props.refreshDatabase}
        onResetStore={this.props.resetStore}
      />
    );
  }
}

const mapStateToProps = state => ({
  database: state.database
});

export default connect(
  mapStateToProps,
  { refreshDatabase, resetStore }
)(withNamespaces(["settings", "common"])(withRouter(Settings)));
